<template>
  <div class="cs-BasicEduTeaLead">
    <!-- 学校领导力 -->
    <div class="cs-BasicEduTeaLead-part1">
      <div class="container">
            <h1 class="tit">学校领导力</h1>
            <p class="p1">“学校领导有责任为学校的愿景、文化、能力、团队、社群、财务和评估制定战略，
从而推动和落实对于学习、教学和学校环境的创新改造。”</p>
            <p class="p2">——摘录来自: Apple 教育《领导力要素》</p>
            <img src="../assets/img/cs-jiaoyu_small.jpg" alt="">
            <p class="p3">创森智云携手 Apple，<br>致力帮助学校领导者为建设富有创新精神的学校奠定基础。</p>
            <p class="p4">我们可以帮您：</p>

            <el-row :gutter="60">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div class="item" style="height:240px">
                        <div class="item-icon">
                            <div class="middle" style="height:240px">
                                <img src="../assets/img/icon-teacherLead-1.png" alt="">
                            </div>
                        </div>
                        <div class="item-con">
                            <div class="middle" style="height:240px">
                                <p class="p1">实现学校愿景</p>
                                <p class="p2">实现你对学习、教学和环境方面心怀的目标与期许。</p>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div class="item" style="height:240px">
                        <div class="item-icon">
                            <div class="middle" style="height:240px">
                                <img src="../assets/img/icon-teacherLead-2.png" alt="">
                            </div>
                        </div>
                        <div class="item-con">
                            <div class="middle" style="height:240px">
                                <p class="p1">提高团队协作</p>
                                <p class="p2">协助学校建立一支具有影响力和创新力的团队。</p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="60">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div class="item" style="height:270px">
                        <div class="item-icon">
                            <div class="middle" style="height:270px">
                                <img src="../assets/img/icon-teacherLead-3.png" alt="">
                            </div>
                        </div>
                        <div class="item-con">
                            <div class="middle"  style="height:270px">
                                <p class="p1">提升学校实力</p>
                                <p class="p2">为学校搭建信息系统，为教师提供资源和指导，提高综合建设水平。</p>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div class="item" style="height:270px">
                        <div class="item-icon">
                            <div class="middle" style="height:270px">
                                <img src="../assets/img/icon-teacherLead-4.png" alt="">
                            </div>
                        </div>
                        <div class="item-con">
                            <div class="middle"  style="height:270px">
                                <p class="p1">与社群建立联系</p>
                                <p class="p2" style="letter-spacing:-0.6px">通过技术在学校中的作用，使学校获得社群的认同和支持。</p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="60">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div class="item item-5" style="height:330px">
                        <div class="item-icon">
                            <div class="middle" style="height:330px">
                                <img src="../assets/img/icon-teacherLead-5.png" alt="">
                            </div>
                        </div>
                        <div class="item-con">
                            <div class="middle" style="height:330px">
                                <p class="p1">引导学校文化</p>
                                <p class="p2">塑造教职工、学生和家长之间的互动方式，创造有关学习、教学和教育的共同理念。</p>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div class="item item-6" style="height:330px">
                        <div class="item-icon">
                            <div class="middle" style="height:330px">
                                <img src="../assets/img/icon-teacherLead-6.png" alt="">
                            </div>
                        </div>
                        <div class="item-con">
                            <div class="middle" style="height:330px;">
                                <p class="p1">设计可持续的财务模型</p>
                                <p class="p2">当学生和教职人员开始使用 Apple 产品和服务，可以大幅调整学校的预算配置，包括技术、学校用品，甚至设施与人事方面的预算考量。</p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
      </div>
    </div>

    <div class="cs-BasicEduTeaLead-part2">
        <div class="container">
            <h1>面向领导者的图书</h1>
            <p class="p1">树立创新思维、塑造创新文化，领导力系列是我们精心为您准备的实用策略工具。</p>
            <el-row type="flex" class="row-bg" justify="center">
                <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                    <img src="../assets/img/teacherLead-1.jpg" alt="">
                    <p class="p2">《领导力要素》</p>
                    <a href="/pdf/领导力要素.ibooks" class="more">点击可下载并阅览完整电子书 <img src="../assets/img/icon-teacherResource-6.png" alt=""></a>
                </el-col>
                <el-col :xs="20" :sm="20" :md="10" :lg="10" :xl="10">
                    <img src="../assets/img/teacherLead-2.jpg" alt="">
                    <p class="p2">《推动学校创新》</p>
                    <a href="/pdf/推动学校创新.ibooks" class="more">点击可下载并阅览完整电子书 <img src="../assets/img/icon-teacherResource-6.png" alt=""></a>
                </el-col>
            </el-row>
        </div>
    </div>

    <div class="cs-page">
        <router-link to="home" active-class="activeClass">首页</router-link>
        <!-- <router-link to="" active-class="activeClass">上一页</router-link> -->
        <router-link to="BasicEduTeacherTraining" active-class="activeClass">下一页</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name:'BasicEduTeacherLeader',
  data() {
    return {
    }
  },
  mounted(){
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
.cs-BasicEduTeaLead{
    border-bottom: 1px solid #D6D6D6;
  .cs-BasicEduTeaLead-part1{
      background: #f5f5f7;
      padding-bottom: 62px;
      .container{
          > img{
              display: block;
              max-width: 860px;
              width: 100%;
              height: auto;
              margin: -40px auto 40px auto;
              border-radius: 22px;
          }
          .tit{
                font-size: 58px;
                font-weight: 600;
                color: #000000;
                line-height: 76px;
                text-align: center;
                padding: 115px 0 91px 0;
          }
          .p1,.p2{
            max-width: 862px;
            margin: 0 auto;
            font-size: 24px;
            font-weight: 600;
            color: #000000;
          }
          .p1{
              line-height: 38px;
              text-align: left;
              text-align: justify;
          }
          .p2{
                line-height: 30px;
                text-align: right;
                margin: 37px 0 86px 0;
          }
          .p3,.p4{
                font-size: 24px;
                font-weight: 400;
                color: #000000;
                line-height: 38px;
                text-align: center;
                margin: 0 auto;
          }
          .p3{
              width: 680px;
          }
          .p4{
              margin: 50px auto 63px auto;
              font-size: 28px;
              color: #0071E3;
              text-align: center;
          }
          .item{
              background: #fff;
              border-radius: 22px;
              word-break: break-word;
              .middle{
                  display: table-cell;
                  vertical-align: middle;
                  width: 100%;
              }
              .item-icon{
                  float: left;
                  text-align: center;
                  .middle{
                        width: 204px;
                    }
              }
              .item-con{
                  float: left;
                  width: 305px;
                  .p1{
                        font-size: 32px;
                        font-weight: 600;
                        color: #000000;
                        line-height: 30px;
                        width: 100%;
                  }
                  .p2{
                        font-size: 24px;
                        font-weight: 400;
                        color: #000000;
                        line-height: 38px;
                        width: 100%;
                        margin: 34px 0 0 0;
                        text-align: justify;
                  }
              }
          }
          .item-6{
              .item-con{
                  width: 325px;
              }
          }
          .item-5{
              .item-con{
                  width: 320px;
              }
          }
          .el-col{
              margin-bottom: 60px;
          }
      }
  }

    .cs-BasicEduTeaLead-part2{
        background: #fff;
        padding: 79px 0;
        .container{
            text-align: center;
            h1{
                font-size: 42px;
                font-weight: 600;
                color: #000000;
                line-height: 38px;
            }
            .p1{
                font-size: 24px;
                font-weight: 400;
                color: #000000;
                line-height: 38px;
                margin: 41px 0 68px 0;
            }
            .p2{
                font-size: 32px;
                font-weight: 600;
                color: #000000;
                line-height: 30px;
                margin: 42px 0 36px;
            }
            .more{
                font-size: 26px;
                font-weight: 400;
                color: #0071E3;
                line-height: 35px;
            }
        }
    }
}

// 适配
@media screen and (max-width: 768px) {
    .cs-BasicEduTeaLead{
        .cs-BasicEduTeaLead-part1{
            .container{
                > img{
                    max-width: 100%;
                    width: 100%;
                    margin: -60px auto 28px auto;
                }
            }
            .p1,.p2, .p3{
                width: auto!important;
            }

            .item{
                padding: 0 20px;
              .item-icon{
                   width: 20%;
                    .middle{
                        width: 100%!important;
                        img{
                            max-width: 100%;
                        }
                    }
              }
              .item-con{
                  width: 80%;
                  float: right!important;
              }
            }
        }
        .cs-BasicEduTeaLead-part2{
            .el-col{
                &:first-child{
                    margin-right: 10px;
                }
                &:last-child{
                    margin-left: 10px;
                }
                .p2{
                    font-size: 24px;
                }
                .more{
                    font-size: 20px;
                    img{
                        height: 15px;
                    }
                }
            }
            img{
                max-width: 100%;
            }
        }
    }
}

@media screen and (max-width: 1250px) {
    .cs-BasicEduTeaLead{
        .cs-BasicEduTeaLead-part1{
            .item{
                padding: 0 20px;
                .item-icon{
                    width: 20%;
                    .middle{
                        width: 100%!important;
                        img{
                            max-width: 100%;
                        }
                    }
                }
                .item-con{
                    width: 79%!important;
                    float: right!important;
                }
            }
        }
    }
}
</style>
